import { useCallback, useMemo } from "react";
import { generatePath, useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

type Props = {
	hotelID: string;
};

export const useNavigateToVoucherPage = ({ hotelID }: Props) => {
	const navigate = useNavigate();

	const createNewVoucherPagePath = useMemo(
		() => generatePath(PATHS.HOTEL.MARKETING.VOUCHER.NEW, { hotelID }),
		[hotelID],
	);
	const duplicateVoucherPagePath = useCallback(
		(voucherID: string) =>
			`${generatePath(PATHS.HOTEL.MARKETING.VOUCHER.NEW, { hotelID })}?duplicateItemID=${voucherID}`,
		[hotelID],
	);
	const editVoucherPagePath = useCallback(
		(voucherID: string) => generatePath(PATHS.HOTEL.MARKETING.VOUCHER.EDIT, { hotelID, voucherID }),
		[hotelID],
	);

	const navigateToCreateNewVoucherPage = useCallback(() => {
		navigate(createNewVoucherPagePath);
	}, [createNewVoucherPagePath, navigate]);

	const navigateToDuplicateVoucherPage = useCallback(
		(voucherID: string) => {
			navigate(duplicateVoucherPagePath(voucherID));
		},
		[duplicateVoucherPagePath, navigate],
	);

	const navigateToEditVoucherPage = useCallback(
		(voucherID: string) => {
			navigate(editVoucherPagePath(voucherID));
		},
		[editVoucherPagePath, navigate],
	);

	return {
		navigateToCreateNewVoucherPage,
		navigateToEditVoucherPage,
		navigateToDuplicateVoucherPage,
	};
};
